import type { UserAttributes } from "hooks/authentication";
import type { CdcUserAttributes } from "models/cdcUser";
import type { ColorSearchSettings } from "models/colors";
import type { AccountType } from "models/whats-new";
import { getDataFromLocalstorageByKey } from "./get-data-localstorage";
import { checkInternalUser } from "./get-user-type";

/**
 * Classifies the viewer with INTERNAL > CUSTOMER_LOUNGE > EXTERNAL precedence.
 * Internal (Covestro/Azure-SSO) users win first; otherwise the presence of a
 * cached `cdcUser` in localStorage marks a federated Customer Lounge visitor,
 * and its absence falls through to a plain EXTERNAL customer.
 *
 * @param user - the authenticated user attributes, if any
 * @param settings - color-search settings consulted by the internal-user check
 * @returns the derived account type used to gate audience-scoped features
 */
export function deriveAccountType(
  user: UserAttributes | undefined,
  settings: ColorSearchSettings,
): AccountType {
  if (checkInternalUser(user, settings)) {
    return "INTERNAL";
  }
  const cdcUser: CdcUserAttributes | undefined =
    getDataFromLocalstorageByKey("cdcUser");
  return cdcUser ? "CUSTOMER_LOUNGE" : "EXTERNAL";
}
